(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.ekbReady) return;
    root.dataset.ekbReady = '1';
    var cfgEl = root.querySelector('[data-ekb-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { cfg = {}; }

    /* gallery */
    var hero = root.querySelector('[data-ekb-hero]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ekb-thumb]'));
    var idx = 0;
    function show(i) {
      if (!thumbs.length || !hero) return;
      idx = (i + thumbs.length) % thumbs.length;
      hero.src = thumbs[idx].getAttribute('data-ekb-thumb');
      thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === idx); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var prev = root.querySelector('[data-ekb-prev]'), next = root.querySelector('[data-ekb-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    if (hero) {
      var sx = null;
      hero.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (sx == null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 40) show(dx < 0 ? idx + 1 : idx - 1);
      }, { passive: true });
    }

    /* add to bag */
    var add = root.querySelector('[data-ekb-add]');
    var addText = root.querySelector('[data-ekb-add-text]');
    var msg = root.querySelector('[data-ekb-msg]');
    function setMsg(t, kind) {
      if (!msg) return;
      msg.textContent = t || '';
      msg.classList.toggle('is-error', kind === 'error');
    }
    if (add) {
      add.addEventListener('click', function () {
        var id = Number(add.getAttribute('data-ekb-add'));
        if (!id || add.disabled) return;
        add.disabled = true; setMsg('');
        var url = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js';
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('failed');
          if (addText) addText.textContent = cfg.addedText || 'Added to bag';
          add.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () {
            add.disabled = false; add.classList.remove('is-added');
            if (addText) addText.textContent = cfg.addText || 'Add to bag';
          }, 1800);
        }).catch(function () {
          add.disabled = false;
          setMsg(cfg.errorText || 'Something went wrong. Please try again.', 'error');
        });
      });
    }
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.ekb'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector('.ekb'); if (r) { delete r.dataset.ekbReady; init(r); } });
})();
